import PremiumLanding from "@/components/PremiumLanding";
export default function Vrat() {
  return <PremiumLanding
    testid="vrat-page"
    badge="YUMO Vrat Intelligence"
    title="Fasting, made effortless."
    tagline="Dedicated intelligence for Hindu fasting traditions."
    description="Vrat brings respectful, region-aware guidance for observant kitchens — from Ekadashi and Shivaratri to Navratri and Karva Chauth. Practices vary; YUMO honors your family's traditions."
    capabilities={[
      { label: "Vrat Recipes", detail: "Curated dishes drawn from YUMO's corpus with clear ingredient allowlists per fast type." },
      { label: "Allowed & Restricted", detail: "Instant clarity on what's permitted for the fast you're observing." },
      { label: "Conversational Guidance", detail: "Ask YumoPot about a specific ritual — get respectful, tradition-aware answers." },
      { label: "Meal Planning", detail: "Fast-friendly meal plans that respect your family's regional practice." },
    ]}
  />;
}
